import React, { useState } from 'react'
import AwardLabelPc from '../../public/award_label_for_pc.png'
import AwardLabelSp from '../../public/award_label_for_sp.png'
import CourseValuePc from '../../public/course_value_pc.png'
import CampaignValuePc from '../../public/campaign_value_pc.png'
import CampaignValueDetailPc from '../../public/campaign_value_detail_pc.png'
import SubsidyValuePc from '../../public/subsidy_value_pc.png'
import SubsidyValueDetailPc from '../../public/subsidy_value_detail_pc.png'
import SubsidyValuePriceDetailPc from '../../public/subsidy_value_price_detail_pc.png'
import CourseValueSp from '../../public/course_value_sp.png'
import CampaignValueSp from '../../public/campaign_value_sp.png'
import CampaignValueDetailSp from '../../public/campaign_value_detail_sp.png'
import SubsidyValueSp from '../../public/subsidy_value_sp.png'
import SubsidyValueDetailSp from '../../public/subsidy_value_detail_sp.png'
import SubsidyValuePriceDetailSp from '../../public/subsidy_value_price_detail_sp.png'
import ValueLabel from '../../public/value_label.png'
import ReservationMoveButton from '../ReservationMoveButton'

type Props = {
  isPc?: boolean
}

export const AwardContentForAB = ({ isPc }: Props) => {
  const [showCampaignDetail, setShowCampaignDetail] = useState(false)
  const [showSubsidyDetail, setShowSubsidyDetail] = useState(false)
  const [showSubsidyPriceDetail, setShowSubsidyPriceDetail] = useState(false)

  const getCampaignImage = () => {
    if (showCampaignDetail) {
      return isPc ? CampaignValueDetailPc : CampaignValueDetailSp
    }
    return isPc ? CampaignValuePc : CampaignValueSp
  }

  const getSubsidyImage = () => {
    if (showSubsidyDetail && showSubsidyPriceDetail) {
      return isPc ? SubsidyValuePriceDetailPc : SubsidyValuePriceDetailSp
    }
    if (showSubsidyDetail) {
      return isPc ? SubsidyValueDetailPc : SubsidyValueDetailSp
    }
    return isPc ? SubsidyValuePc : SubsidyValueSp
  }

  const handleCampaignClick = () => {
    setShowCampaignDetail(!showCampaignDetail)
  }

  const handleSubsidyClick = () => {
    setShowSubsidyDetail(!showSubsidyDetail)
  }

  const handleSubsidyPriceClick = () => {
    setShowSubsidyPriceDetail(!showSubsidyPriceDetail)
  }

  return (
    <>
      <section id="award-content" className="pt-0 bg-white">
        <div className="bg-[#fff4f1] pt-5 text-center w-full">
          <img
            src={isPc ? AwardLabelPc.src : AwardLabelSp.src}
            className="w-full h-auto"
          />
        </div>

        <div className="bg-[#e6f0f0] text-center pb-[30px]">
          {isPc ? (
            <div className="flex flex-col items-center gap-5 py-5">
              <img
                src={ValueLabel.src}
                className="h-auto lg:w-1/5 max-lg:w-1/2 sm:w-4/5"
              />
              <img
                src={CourseValuePc.src}
                className="lg:w-[55%] sm:w-[90%] h-auto"
              />
              <div className="flex justify-center items-start gap-0 w-full lg:w-[55%] lg:gap-5">
                <div className="relative w-[90%] md:w-[70%] lg:w-[50%]">
                  <div
                    className={`absolute cursor-pointer w-[210px] h-[30px] max-lg:w-[300px] max-lg:h-[30px] sm:w-[180px] sm:h-[20px] ${
                      showCampaignDetail
                        ? 'bottom-[27%] left-[4%] max-lg:bottom-[28%] max-lg:left-[4%]'
                        : 'bottom-[2%] left-[4%] max-lg:bottom-[7%] max-lg:left-[4%] sm:bottom-[4%] sm:left-[4%]'
                    }`}
                    onClick={handleCampaignClick}
                  />
                  <img
                    src={getCampaignImage().src}
                    className="w-full h-auto block"
                  />
                </div>
                <div className="relative w-[90%] md:w-[70%] lg:w-[50%]">
                  <div
                    className={`absolute cursor-pointer w-[210px] h-[30px] max-lg:w-[300px] max-lg:h-[30px] sm:w-[180px] sm:h-[20px] ${
                      showSubsidyDetail
                        ? 'bottom-[42%] left-[4%] max-lg:bottom-[49%] max-lg:left-[4%] sm:bottom-[48%] sm:left-[4%]'
                        : 'bottom-[2%] left-[4%] max-lg:bottom-[7%] max-lg:left-[4%] sm:bottom-[6%] sm:left-[4%]'
                    }`}
                    onClick={handleSubsidyClick}
                  />
                  {showSubsidyDetail && (
                    <>
                      <div
                        className={`absolute cursor-pointer w-[210px] h-[30px] max-lg:w-[200px] max-lg:h-[30px] sm:w-[180px] sm:h-[20px] ${
                          showSubsidyPriceDetail
                            ? 'bottom-[69%] left-[4%] max-lg:bottom-[76.8%] max-lg:left-[4%] sm:bottom-[77%] sm:left-[4%]'
                            : 'bottom-[3%] left-[4%]'
                        }`}
                        onClick={handleSubsidyPriceClick}
                      />
                      <a
                        className="absolute cursor-pointer w-[35px] h-[20px] left-[33%] bottom-[9%] sm:w-[50px] sm:h-[30px] sm:left-[17%] sm:bottom-[6%]"
                        href="https://shelikes.jp/landing_pages/price"
                        target="_blank"
                        rel="noreferrer"
                      />
                    </>
                  )}
                  <img
                    src={getSubsidyImage().src}
                    className="w-full h-auto block"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-2.5 py-5">
              <img src={ValueLabel.src} className="h-auto w-4/5" />
              <img
                src={CourseValueSp.src}
                className="lg:w-[55%] w-[90%] h-auto"
              />
              <div className="relative w-[90%] md:w-[70%] lg:w-[50%]">
                <div
                  className={`absolute cursor-pointer w-[210px] h-[30px] max-lg:w-[300px] max-lg:h-[30px] sm:w-[180px] sm:h-[20px] ${
                    showCampaignDetail
                      ? 'bottom-[27%] left-[4%] max-lg:bottom-[28%] max-lg:left-[4%]'
                      : 'bottom-[2%] left-[4%] max-lg:bottom-[7%] max-lg:left-[4%] sm:bottom-[4%] sm:left-[4%]'
                  }`}
                  onClick={handleCampaignClick}
                />
                <img
                  src={getCampaignImage().src}
                  className="w-full h-auto block"
                />
              </div>
              <div className="relative w-[90%] md:w-[70%] lg:w-[50%]">
                <div
                  className={`absolute cursor-pointer w-[210px] h-[30px] max-lg:w-[300px] max-lg:h-[30px] sm:w-[180px] sm:h-[20px] ${
                    showSubsidyDetail
                      ? 'bottom-[42%] left-[4%] max-lg:bottom-[49%] max-lg:left-[4%] sm:bottom-[48%] sm:left-[4%]'
                      : 'bottom-[2%] left-[4%] max-lg:bottom-[7%] max-lg:left-[4%] sm:bottom-[6%] sm:left-[4%]'
                  }`}
                  onClick={handleSubsidyClick}
                />
                {showSubsidyDetail && (
                  <>
                    <div
                      className={`absolute cursor-pointer w-[210px] h-[30px] max-lg:w-[200px] max-lg:h-[30px] sm:w-[180px] sm:h-[20px] ${
                        showSubsidyPriceDetail
                          ? 'bottom-[69%] left-[4%] max-lg:bottom-[76.8%] max-lg:left-[4%] sm:bottom-[77%] sm:left-[4%]'
                          : 'bottom-[3%] left-[4%]'
                      }`}
                      onClick={handleSubsidyPriceClick}
                    />
                    <a
                      className="absolute cursor-pointer w-[35px] h-[20px] left-[33%] bottom-[9%] sm:w-[50px] sm:h-[30px] sm:left-[17%] sm:bottom-[6%]"
                      href="https://shelikes.jp/landing_pages/price"
                      target="_blank"
                      rel="noreferrer"
                    />
                  </>
                )}
                <img
                  src={getSubsidyImage().src}
                  className="w-full h-auto block"
                />
              </div>
            </div>
          )}
          <ReservationMoveButton
            moveToId="reservation-step-summary"
            isAB={true}
          />
        </div>
      </section>
    </>
  )
}
